module.exports = __webpack_public_path__ + "img/30000.8b46259f.png";